/* dev/assets/js/a-video.js */
(function ($) {
    "use strict";
    $(function () {

        $.cookieSettings = Cookies.get('DONEGDPRConsent');

        if ($.cookieSettings != undefined) {
            $.cookieSettings = JSON.parse($.cookieSettings);
        }

        $('.youtube-player-wrapper').each(function () {
            var $videotext = $(this).data('text');
            var $yid = $(this).data('id');
            var $image = $(this).data('image');

            if ($.cookieSettings != undefined && $.cookieSettings.functional == true) {
                $(this).append(`<div class="youtube-player" data-id="${$yid}">
            <div data-id="${$yid}">
            <img src="${$image}" alt="">
            <span class="play"></span>
            </div>
            </div>
            <span class="overlay overlay--light"></span>
            ${($videotext) ? `  <p class="video-text">
            ${$videotext}
            </p>`: ``}
            `);
            } else {
                $(this).append(`
                <div class="modify-cookie-settings">
                <p>${localize.translations.modifyCookieYoutube}</p>
                <div class="open-cookie js-open-cookie">
                 <a href="#" class="button button--secondary">${localize.translations.cookieSettings}</a>
                </div>
                </div>
                `);
            }
        });

        $('.spotify-player-wrapper').each(function () {
            var $url = $(this).data('url');


            if ($.cookieSettings != undefined && $.cookieSettings.functional == true) {
                $(this).html(`<iframe src="${$url}" width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`);
            } else {
                $(this).append(`
                <div class="modify-cookie-settings">
                <p>${localize.translations.modifyCookieSpotify}</p>
                <div class="open-cookie js-open-cookie">
                 <a href="#" class="button button--secondary">${localize.translations.cookieSettings}</a>
                </div>
                </div>
                `);
            }
        });



        $('.youtube-player').on('click', function () {
            if ($.cookieSettings != undefined && $.cookieSettings.functional == true) {
                $(this).html(`<iframe src="https://www.youtube.com/embed/${$(this).data('id')}?autoplay=1&amp;rel=0" frameborder="0" allowfullscreen="1"></iframe>`);
            }
        });


        $('.livestream-youtube-player').on('click', function () {
            $(this).html(`<iframe src="https://www.youtube-nocookie.com/embed/live_stream?channel=${$(this).data('id')}&autoplay=1&amp;rel=0" frameborder="0" allowfullscreen="1"></iframe>`);
        });
        

        $('.js-jarallax-video').jarallax({
            speed: 1,
            videoVolume: 0,
            automaticResize: true,
            videoPlayOnlyVisible: true,
        });
    });
})(jQuery);
